import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'perf',
  standalone: true
})
export class PerformancePipe implements PipeTransform {

  transform(url: string|undefined): string|undefined {
    return typeof url == 'string' ? url.replace('/quality/', '/performance/').split('.').slice(0, -1).join('.') + '.webp' : url;
  }

}
